'use strict';
module.exports = function scaleDashes(dashString, width) {
	if (!dashString || width < 2 || !Number.isFinite(width)) {
		return dashString || '';
	}
	return dashString.split(',').map(t => parseInt(t) + width - 1).join(',');
};
